import { render, staticRenderFns } from "./ApplicationWorkplace.vue?vue&type=template&id=7c68d3e7&scoped=true&"
import script from "./ApplicationWorkplace.vue?vue&type=script&lang=js&"
export * from "./ApplicationWorkplace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c68d3e7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
